import { GProgressProps } from '@gazin/ecommerce-ui'

type StylesType = {
  successModal: GProgressProps
}

export const getStyles = (): StylesType => ({
  successModal: {
    borderRadius: 'full',
    color: 'success',
    hasStripe: false,
    height: '0.5rem',
    isAnimated: false,
    isIndeterminate: false,
    time: 1,
    variant: 'solid',
  },
})
